import React from 'react';
import { useAuth } from '../context/AuthContext';

const ApolloAppSyncProvider = React.lazy(() => import('./ApolloAppSyncProvider.jsx'));

const ApolloProviderGate = ({ children }) => {
    const { isAuthenticated } = useAuth();

    if (!isAuthenticated) {
        return children;
    }

    return (
        <React.Suspense fallback={null}>
            <ApolloAppSyncProvider>{children}</ApolloAppSyncProvider>
        </React.Suspense>
    );
};

export default ApolloProviderGate;
